import React, { useEffect, useState } from "react";
import "./rewards.css";
import { NavLink } from "react-router-dom";
import tt_question from "../../assets/images/tt_question.png";
import pats from "../../assets/images/pats.png";
import rupee from "../../assets/images/rupee.png";
import ribbon from "../../assets/images/ribbon.png";
import "../home/popupplug.css";

import arrowLeft from "../../assets/images/arrow_left.png";
import arrowRight from "../../assets/images/arrow_right.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import giftBox from "../../assets/images/gift-box.png";
import shopping from "../../assets/images/shopping.png";
import travel from "../../assets/images/travel.png";
import entertainment from "../../assets/images/entertainment.png";
import food from "../../assets/images/food.png";
import grocery from "../../assets/images/grocery.png";
import electronics from "../../assets/images/electronics.png";
import ecomm from "../../assets/images/ecom.png";
// import arrowLeft from "../../assets/images/ecomm.png";
import $ from 'jquery';
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);


function Rewards() {

  const [earnedPats, setEarnedPats] = useState(0);
  const [rewards, setRewards] = useState([]);

  useEffect(() => {

    fetch(process.env.REACT_APP_API_URL + "api/user/pats")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setEarnedPats(data.pats.earnedPats);
        }
      });

    fetch(process.env.REACT_APP_API_URL + "api/rewards/all")
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setRewards(data.rewards);
        }
      });

  }, [])

  const handleCategoryChange = (category) => {
    //console.log(category);
    fetch(process.env.REACT_APP_API_URL + `api/rewards/${category}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          var $links = $('.reward-category');
          $links.click(function () {
            $links.removeClass('active');
            $(this).addClass('active');
          });
          // $(`#${category}`).addClass('active');
          setRewards(data.rewards);
        }
      });
  }

  return (
    <section>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="tt-title-wrap">
          <div className="tt-title">
            <h1>
              You have <span>{earnedPats} pats</span> to redeem!
            </h1>
            <div className="tt-icon">
              <img src={tt_question} alt="tooltip" />
              <div className="tt-text">
                <p>
                  The pats that you have earned can be used to redeem below
                  rewards.
                </p>
              </div>
            </div>
          </div>
          <div className="rd-sub-title">
            <div className="rd-sub-item">
              <div className="rd-sub-img">
                <img src={pats} alt="" />
              </div>
              <p className="rd-sub-text">1 Pat</p>
            </div>
            <div className="rb-sub-item">
              <p className="rd-sub-text rd-equal">=</p>
            </div>
            <div className="rd-sub-item">
              <div className="rd-sub-img">
                <img src={rupee} alt="" />
              </div>
              <p className="rd-sub-text">1 INR</p>
            </div>
          </div>
        </div>
        <div>
          <NavLink to={"/rewards/history"} className="rewardHistory">
            <span>Reward History</span>
          </NavLink>
        </div>
      </div>

      <div className="rd-wrap">

        <div className="cv-slider-wrap">
          <Swiper
            slidesPerView={4.5}
            spaceBetween={20}
            navigation={(true, { nextEl: ".cv-next", prevEl: ".cv-prev" })}
            className="cv-slider"
          >
            <SwiperSlide >
              <div className="reward-category active" onClick={() => handleCategoryChange('all')} id="all">
                <img src={giftBox} style={{ width: "20px" }} />
                <p>All</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('fashion')} id="fashion">
                <img src={shopping} style={{ width: "20px" }} />
                <p>Fashion & Lifestyle</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('travel')} id="travel">
                <img src={travel} style={{ width: "20px" }} />
                <p>Travel</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('electronics')} id="electronics">
                <img src={electronics} style={{ width: "20px" }} />
                <p>Electronics</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('ecomm')} id="ecomm">
                <img src={ecomm} style={{ width: "20px" }} />
                <p>E-comm</p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('food')} id="food">
                <img src={food} style={{ width: "20px" }} />
                <p>Food</p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('ott')} id="ott">
                {/* <img src={ } style={{ width: "20px" }} /> */}
                <p>OTT Subscription</p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('grocery')} id="grocery">
                <img src={grocery} style={{ width: "20px" }} />
                <p>Grocery</p>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="reward-category" onClick={() => handleCategoryChange('entertainment')} id="entertainment">
                <img src={entertainment} style={{ width: "20px" }} />
                <p>Entertainment</p>
              </div>
            </SwiperSlide>

          </Swiper>
          <img src={arrowRight} className={"cv-arrow cv-next"} style={{ right: "-20px" }} alt="next" />
          <img src={arrowLeft} className={"cv-arrow cv-prev"} style={{ left: "-20px" }} alt="prev" />
        </div>

        <div className="row mobile-rewards" style={{ marginTop: "50px" }}>
          {
            rewards.map((element) => {
              return (
                <>
                  {
                    <div className="col-lg-4 col-md-6 cat-rewards" key={element.RewardID}>
                      <div className="rd-card">
                        <img className="rd-ribbon" src={ribbon} alt="" />
                        <div className="rd-img">
                          <img
                            src={process.env.REACT_APP_REWIMG_URL + element.RewardImage}
                            alt="Reward Image"
                          />
                        </div>
                        <div className="rd-text">
                          <p>{element.RewardName}</p>
                        </div>
                        <NavLink to={"/rewards/" + element.RewardID + "/" + element.RewardName}>
                          Redeem
                        </NavLink>

                      </div>
                    </div>}
                </>
              );
            })
          }
        </div>

        {/* <div className="rd-card-wrap" >
          <div className="row">

            <Tabs>
              <TabList>
                <Tab>All</Tab>
                <Tab>Fashion & Lifestyle</Tab>
                <Tab>Travel</Tab>
                <Tab>Electronics</Tab>
                <Tab>E-comm</Tab>
                <Tab>Food</Tab>
                <Tab>OTT Subscription</Tab>
                <Tab>Grocery</Tab>
                <Tab>Entertainment</Tab>



              </TabList>

              <div className="profile-pp-wrap">
                <TabPanel>
                  <AllRewards />
                </TabPanel>
                <TabPanel>
                  <Fashion />
                </TabPanel>
                <TabPanel>
                  <Travel />
                </TabPanel>
                <TabPanel>
                  <Electronics />
                </TabPanel>
                <TabPanel>
                  <Ecomm />
                </TabPanel>
                <TabPanel>
                  <Food />
                </TabPanel>
                <TabPanel>
                  <Ott />
                </TabPanel>
                <TabPanel>
                  <Grocery />
                </TabPanel>
                <TabPanel>
                  <Entertainment />
                </TabPanel>
              </div>

            </Tabs>

          </div>
        </div> */}
      </div>


    </section>
  );
}

export default Rewards;
